// extracted by mini-css-extract-plugin
export default {"videobox":"RwdYoutube_videobox__oRNS6"};